import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-not-found-view",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./not-found-view.component.html",
  styleUrl: "./not-found-view.component.scss",
})
export class NotFoundViewComponent {
  @Input({ required: true }) titleKey!: string;
  @Input({ required: true }) hintKey!: string;
  @Input({ required: true }) backLabelKey!: string;
  @Input() fullViewport = false;
  @Output() back = new EventEmitter<void>();
}
